import { render, staticRenderFns } from "./Bubble3.vue?vue&type=template&id=fb27825e"
import script from "./Bubble3.vue?vue&type=script&lang=js"
export * from "./Bubble3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports